import AxiosClient from "../../services/axios.services";

class DivisionServices {
  getDivisions = (params, iType) =>
    AxiosClient.get(
      iType === 1
        ? "/api/app/Formal_Division/"
        : "/api/app/Funcional_Division/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveDivision = (data, iType) =>
    AxiosClient.post(
      iType === 1
        ? "/api/app/Formal_Division/"
        : "/api/app/Funcional_Division/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editDivision = (id, data, iType) =>
    AxiosClient.put(
      iType === 1
        ? `/api/app/Formal_Division/${id}/`
        : `/api/app/Funcional_Division/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteDivision = (id, iType) =>
    AxiosClient.delete(
      iType === 1
        ? `/api/app/Formal_Division/${id}/`
        : `/api/app/Funcional_Division/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new DivisionServices();
